import apiClient from './client'

/**
 * 折扣码（结账直接抵扣）
 */
export const discountCodeApi = {
  /**
   * 校验折扣码并预览减免
   * @param {string} code
   * @param {number|string} productId
   */
  validate(code, productId) {
    return apiClient.get('/discount-codes/validate', {
      params: { code, product_id: productId }
    })
  }
}
